import React from "react"
import { NavListItem } from "@kuali/kuali-ui/lib/nav-lists"
import { SidebarLinkConfig } from "./types"

export const PrimaryNavLinks = ({
  primaryLinkData,
  onLinkClick
}: {
  primaryLinkData: Array<SidebarLinkConfig>
  onLinkClick?: (event: React.SyntheticEvent) => void
}): NavListItem => {
  const primaryLinks = primaryLinkData.map((item, index) => {
    const isActive = item.isActive
    return [
      <li key={index} onClick={onLinkClick}>
        <NavListItem
          active={isActive}
          aria-current={isActive ? "page" : undefined}
          iconName={item.iconName}
          container="a"
          target={item.target}
          href={item.href}
          title={item.linkName}
        >
          {item.linkName}
        </NavListItem>
      </li>
    ]
  })

  return primaryLinks
}
